import { RuleEditorDropdownMode, RuleEditorDropdownModeCategory } from '../NodeEditorDrawer/types';

export enum CaretIndexType {
  RULES = 'rules',
  EXPRESSION = 'expression',
  MLA = 'mla',
}

export const startingCaretPosition = '-1!caret';
export const mlaCTACaretPositionString = 'cta-0!mlaAddOptionalFilter';

export const ruleEditorModeToCategoryMap = {
  // GROUP
  [RuleEditorDropdownMode.GROUP_START]: RuleEditorDropdownModeCategory.GROUP,
  [RuleEditorDropdownMode.GROUP_START_PENDING]: RuleEditorDropdownModeCategory.GROUP,
  [RuleEditorDropdownMode.GROUP_END]: RuleEditorDropdownModeCategory.GROUP,

  // DATAROUTE
  [RuleEditorDropdownMode.DATAROUTE_SOURCE]: RuleEditorDropdownModeCategory.DATAROUTE,
  [RuleEditorDropdownMode.DATAROUTE_ATTRIBUTE]: RuleEditorDropdownModeCategory.DATAROUTE,

  // THRESHOLD
  [RuleEditorDropdownMode.THRESHOLD_LEFT_ACTION]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode.THRESHOLD_LEFT_ATTRIBUTE]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode.THRESHOLD_OPERATOR]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode.THRESHOLD_RIGHT_ACTION]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_ATTRIBUTE_VALUE]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MAX]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MIN]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_ATTRIBUTE_VALUE_BOOLEAN]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_ATTRIBUTE_VALUE_REASONCODEGROUP]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_ATTRIBUTE_VALUE_MULTISELECT]: RuleEditorDropdownModeCategory.THRESHOLD,
  [RuleEditorDropdownMode
    .THRESHOLD_RIGHT_TAGACTIONRESULT]: RuleEditorDropdownModeCategory.THRESHOLD,
};
